import * as React from 'react';
import { FormControl, FormHelperText, FormLabel, TextField } from '@mui/material';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import { Listbox } from '@features/effector-form/components/listbox';
import { withControl } from '@features/effector-form/hoc/withControl';
import i18n from '@shared/config/i18n';

const { t } = i18n;

export const ObjectTypeControl = withControl<
  Partial<AutocompleteProps<any, any, any, any>>
>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    multiple,
    isError,
  }) => {
    const options = [
      { id: 'complex', label: t('complex') },
      { id: 'building', label: t('building') },
      { id: 'entrance', label: t('rizer') },
      { id: 'floor', label: t('Floor') },
      { id: 'elevator', label: t('Elevator') },
      { id: 'apartment', label: t('Apartments') },
      { id: 'room', label: t('Room') },
      { id: 'passage', label: t('Transition') },
      { id: 'office', label: t('Office') },
      { id: 'retail', label: t('Retail') },
      { id: 'coworking', label: t('Coworking') },
      { id: 'parking_place', label: t('parking') },
      { id: 'parking_zone', label: t('parkingZone') },
      { id: 'parking_lot', label: t('parkingSpace') },
      { id: 'pantry', label: t('pantry') },
      { id: 'property_place', label: t('TechnicalRoom') },
      { id: 'property', label: t('room') },
      { id: 'workplace', label: t('Workplace') },
    ];

    const handleChange = (event: any, newValue: any) => {
      if (multiple) {
        setValue(newValue.map((item: any) => item.id) || null);
      } else {
        setValue(newValue?.id || null);
      }
    };

    const getValue = () =>
      multiple
        ? options.filter((item) => value?.indexOf(item.id) > -1)
        : options.find((item) => item.id === value);

    return (
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <Autocomplete
          value={getValue()}
          options={!options ? [] : options}
          onChange={handleChange}
          slotProps={{
            listbox: {
              component: Listbox,
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              slotProps={{
                input: {
                  ...params.InputProps,
                  required,
                  readOnly,
                  disabled,
                  error: isError,
                },
              }}
            />
          )}
          readOnly={readOnly}
          disabled={disabled}
          multiple={multiple}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
